<div class="ar-preview-container">
  <ng-container>
    <!-- <model-viewer style="width:1000px;height:700px;margin: auto;" camera-controls ar ar-modes="webxr scene-viewer quick-look" src="../../../assets/ar/Yephome- AR.glb"
      data-js-focus-visible="" ar-status="not-presenting">
    </model-viewer> -->
    <model-viewer
      class="mobile-vr"
      style="width:1000px;height:700px;margin: auto;" camera-controls ar
      ar-modes="webxr scene-viewer quick-look" src="https://developer.yephome.com.au/images/Yephome-AR.glb"
      poster="./assets/images/home/glb_loading.jpg" data-js-focus-visible="" ar-status="not-presenting">
    </model-viewer>
    <!-- <model-viewer style="width:1000px;height:700px;margin: auto;" camera-controls ar ar-modes="webxr scene-viewer quick-look" src="https://developer.yephome.com.au/images/Yephome-AR.glb"
    poster="./assets/images/home/glb_loading.jpg"
      data-js-focus-visible="" ar-status="not-presenting">
    </model-viewer> -->
  </ng-container>
</div>
